/* eslint-disable */
import axios from 'axios'
import { AssistanceDeviceZk } from '@/models/assistance'

const URL = 'http://localhost:8000/'

class ZKLibService {

  async connect (ipDevice: string, port: number): Promise<{ success: boolean, msg: string}> {
    return new Promise(( resolve, reject) => {
      axios.get(`${URL}test_connection?ip=${ipDevice}&port=${port}`).then( response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }

  async getInfo (ipDevice: string, port: number): Promise<{ success: boolean, msg: string, users: number, attendances: number }> {
    return new Promise(( resolve, reject) => {
      axios.get(`${URL}get_info?ip=${ipDevice}&port=${port}`).then( response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }

  async getAssistances (ipDevice: string, port: number): Promise<{ success: boolean, msg: string, data: AssistanceDeviceZk[] }> {
    return new Promise(( resolve, reject ) => {
      axios.get(`${URL}get_assits_by_date?ip=${ipDevice}&port=${port}`).then( response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }

  async getAssistancesByDate (ipDevice: string, port: number, dateStart: string, dateEnd: string): Promise<{ success: boolean, msg: string, data: AssistanceDeviceZk[] }> {
    return new Promise(( resolve, reject ) => {
      axios.get(`${URL}get_assits_by_date?ip=${ipDevice}&port=${port}&date_init=${dateStart}&date_final=${dateEnd}`).then( response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default new ZKLibService()
